// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"0c2f143d","455":"f0b2de11","457":"e104aeac","977":"d86e0608"}[chunkId] + ".chunk.js";
};